<template>
  <v-container fluid class="add-device fill-height">
    <ExitConfirmation
      v-show="exitConfirmationDialog"
      :exitConfirmationDialog.sync="exitConfirmationDialog"
    />
    <v-layout v-show="!exitConfirmationDialog" class="div-center-horizontally">
      <v-flex xs12 sm12>
        <v-container class="medium-div">
          <v-layout row class="header-row">
            <v-flex class="div-center-vertically">
              <p class="equipment-data">{{$t('AddDevice.equipmentData')}}</p>
            </v-flex>
            <v-flex class="div-center-vertically div-right-horizontally">
              <v-btn icon @click="close">
                <v-icon class="close-icon">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="device-content-row">
            <v-flex xs12 style="height: 100%">
              <DeviceEditor :deviceDataProp="deviceData" :deviceLength="length" :pluviometricChartData="pluviometricChartData"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DeviceEditor from './AddDevice/DeviceEditor'
import ExitConfirmation from './ExitConfirmation'
import { parsePluviometricChartData, isoDateToSlashes } from '../../lib/helpers'
import get from 'lodash/get'

export default {
  components: {
    DeviceEditor,
    ExitConfirmation
  },
  data () {
    const deviceData = this.getInitialDeviceData(this.$route.params.device)

    return {
      organization: this.$store.getters.userOrganization.name,
      deviceData,
      length: get(this, '$route.params.device.equipment.length', 0) || 0,
      pluviometricChartData: {},
      exitConfirmationDialog: false
    }
  },
  methods: {
    close () {
      this.exitConfirmationDialog = true
    },
    getInitialDeviceData (device) {
      const data = {
        id: get(device, 'id', ''),
        name: get(device, 'campaign.entityName', ''),
        type: get(device, 'equipment.type', ''),
        subtype: get(device, 'equipment.subtype', ''),
        positionNotification: get(device, 'equipment.positionNotification', false),
        equipment: get(device, 'equipment', {}),
        serviceStartDate: get(device, 'serviceStartDate'),
        hasCompleteData: get(device, 'hasCompleteData', null),
        zoom: get(device, 'zoom', null)
      }

      const pluviometricCharts = device && device.pluviometricCharts
      if (pluviometricCharts && pluviometricCharts.length) {
        data.pluviometricCharts = pluviometricCharts.map(chart => {
          const {pluviometricChartFile, validityDate, creationDate, parsedChartId} = parsePluviometricChartData(chart)
          return {
            parsedChartId,
            validityDate,
            auxValidityDate: validityDate ? validityDate.split('T')[0] : '',
            formattedValidityDate: validityDate ? isoDateToSlashes(validityDate) : '',
            creationDate,
            auxCreationDate: creationDate ? creationDate.split('T')[0] : '',
            formattedCreationDate: creationDate ? isoDateToSlashes(creationDate) : '',
            pluviometricChartFile,
            isActive: chart.isActive,
            linkToFile: chart.linkToFile
          }
        }).sort((a, b) => new Date(a.validityDate) - new Date(b.validityDate))
      } else {
        const serviceStartDateISO = data.serviceStartDate.toISOString()
        data.pluviometricCharts = [{
          parsedChartId: '',
          validityDate: serviceStartDateISO,
          auxValidityDate: serviceStartDateISO.split('T')[0],
          formattedValidityDate: isoDateToSlashes(serviceStartDateISO),
          creationDate: '',
          auxCreationDate: '',
          formattedCreationDate: '',
          pluviometricChartFile: undefined,
          isActive: false
        }]
      }

      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddDevice.vue?3f52cd98